module.exports = __webpack_public_path__ + "dea59f39f870319219580c42052ac95b.png";